import { Grid } from '@mui/material';
import { RoutalLoader, RoutalPalette } from '@nx-smartmonkey/ui';

import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';
import Text from '../../../../react-components/Text';
import { CreatePlan } from '../create-plan/CreatePlan';
import { useManagePlanQuery } from '../hooks/useManagePlanQuery';
import { useSearchSelectedDayPlans } from '../hooks/useSearchSelectedDayPlans';
import { HEADER_HEIGHT } from './PlannerPlansDayHeader';
import { PlannerPlansDayPlanPill } from './PlannerPlansDayPlanPill';

interface PlannerPlansDayListProps {
  selectedDay: Date;
}

export const PlannerPlansDayList = ({ selectedDay }: PlannerPlansDayListProps) => {
  const { navigateToPlan } = useManagePlanQuery();
  const { data: activeProject } = useRetrieveActiveProject();
  const { data: plans, isLoading } = useSearchSelectedDayPlans({ project: activeProject, selectedDay });
  return (
    <Grid container direction="column" wrap="nowrap" style={{ height: `calc(100% - ${HEADER_HEIGHT}px` }}>
      {isLoading ? (
        <Grid
          container
          direction="column"
          wrap="nowrap"
          justifyContent="center"
          alignItems="center"
          style={{ height: `100%`, overflow: `hidden` }}
        >
          <RoutalLoader />
        </Grid>
      ) : (
        <>
          {(plans ?? []).length > 0 ? (
            <Grid
              container
              gap="12px"
              wrap="nowrap"
              direction="column"
              style={{ height: `100%`, overflowY: `auto`, padding: `12px 16px` }}
            >
              {plans!.map((plan) => (
                <PlannerPlansDayPlanPill key={plan.id} plan={plan} />
              ))}
            </Grid>
          ) : (
            <Grid
              container
              gap="8px"
              wrap="nowrap"
              direction="column"
              alignItems="center"
              style={{ height: `100%`, overflowY: `auto`, padding: `12px 16px` }}
            >
              <Text style={{ padding: `16px 0` }} variant="label" intlId="planner.plans.day_plans.empty" />
            </Grid>
          )}
        </>
      )}

      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ borderTop: `1px solid ${RoutalPalette.neutral10}`, padding: `12px 16px`, width: `100%` }}
      >
        <CreatePlan
          buttonProps={{
            id: `create-plan-button`,
            styleType: `primary`,
            style: { width: `100%` },
          }}
          selectedDay={selectedDay}
          handleAfterCreatePlan={(newPlanId: string, executionDate: Date) => {
            navigateToPlan({ planId: newPlanId, invalidateQueries: true });
          }}
        />
      </Grid>
    </Grid>
  );
};
